export default "__VITE_ASSET__8e9a4554__"